var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.showEpidemicTips ? _c('div', {
    staticClass: "component-epidemic-tips",
    style: {
      'z-index': _vm.zIndex
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.onClickTips.apply(null, arguments);
      }
    }
  }, [_c('p', {
    staticClass: "p-tips"
  }, [_vm._v(_vm._s(_vm.ncpMessage))]), _c('span', {
    staticClass: "btn-close",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        _vm.showEpidemicTips = 0;
      }
    }
  })]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };